import Register from '../views/Register'
import HelpManual from '../views/HelpManual'
import DeviceMap from '../views/DeviceMap'
import Agreement from '../views/mobile/agreement'

//  import Main from '../views/Main'

const routers = [
  {
    path: '/',
    name: 'Index',
    component: resolve => require(['../views/Index'], resolve)
  },
  {
    path: '/private',
    name: 'Private',
    component: resolve => require(['../views/Private'], resolve)
  },
  {
    path: '/download',
    name: 'Download',
    component: resolve => require(['../views/Download'], resolve)
  },
  {
    path: '/login',
    name: 'login',
    component: resolve => require(['../views/Login'], resolve)
  },
  {
    path: '/licenceLogin',
    name: 'licenceLogin',
    component: resolve => require(['../views/LicenceLogin'], resolve)
  },
  {
    path: '/helpManual',
    name: 'helpManual',
    component: HelpManual
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  // {
  //   path: '/main',
  //   name: 'main',
  //   component:Main
  // },
  {
    path: '/main',
    name: 'main',
    component: resolve => require(['../views/Main'], resolve)
  },
  {
    path: '/profile',
    name: 'profile',
    component: resolve => require(['../views/Profile'], resolve)
  },
  {
    path: '/forbid',
    name: 'Forbid',
    component: resolve => require(['../views/Forbid'], resolve)
  },
  {
    path: '/deviceMap',
    name: 'DeviceMap',
    component: DeviceMap
  },
  {
    path: '/mobile/Agreement',
    nbame: 'Agreement',
    component:Agreement
  }
]

export default routers



// WEBPACK FOOTER //
// ./src/routers/common.js